import { useParams } from 'react-router-dom';
import { useQueryFileSystem } from 'app/domains/filesystem/components/FileSystem/FileSystemProvider/useQueryFileSystem';
export const useCurrentFolder = () => {
    const { folderId } = useParams();
    const { data } = useQueryFileSystem(folderId);
    const { folder } = data || {};
    const normalizedFolder = folder ? { id: folder.id, name: folder.name } : undefined;
    return { currentFolder: normalizedFolder };
};
